import React from 'react';

import { Loader } from 'Components';

/*
  <LoadingComponent> is a component to be displayed while keycloak is being initialized,
  if not provided child components will be rendered immediately. Defaults to null
*/
export default function LoadingComponent() {
  const loadingMessages = [
    'Loading your Data Journey, please wait.',
    'Loading SDP Console, please wait.',
    'Loading all your data experience, please wait behind the line...',
    'Getting everything ready, please wait a few moments.',
    'Great to see you on the path to data excellence.'
  ];

  return (
    <main className="sdp-main" data-testid="loading-component">
      <div
        className="flex align-items-center justify-content-center flex-column w-100 h-100 sdp-p-absolute"
        style={{
          top: 0,
          bottom: 0
        }}
      >
        <h1>
          {loadingMessages[Math.floor(Math.random() * loadingMessages.length)]}
        </h1>
        <Loader />
      </div>
    </main>
  );
}
